export default __webpack_public_path__ + "static/togogo-97dd0f2f99deb42d90f0430c022db76c.png";